import { createFileRoute } from '@tanstack/react-router';
import { DripGoalSubTab } from '@/components/admin/DripGoalSubTab';

function Page() {
  return <DripGoalSubTab goal='activation' />;
}

export const Route = createFileRoute('/admin/drip-campaigns/activation')({
  component: Page,
});
